import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, rdata) {
  return useMemo(() => {
    if (!rdata) return rdata

    let { tasks_boards, app_admin_users_access: locations } = rdata

    if (!locations || locations?.length === 0) return tasks_boards

    let location_ids = locations.map(location => location.organization_id)

    // only allow movement between boards that the assignee also has access to
    return tasks_boards.filter(board =>
      board.metadata?.locations?.some(loc => location_ids.includes(loc))
    )
  }, [rdata])
}
